import type { ReactNode } from 'react';

interface HomeFeedSectionProps {
  title: string;
  children: ReactNode;
  itemCount: number;
}

export function HomeFeedSection({ title, children, itemCount }: HomeFeedSectionProps) {
  if (itemCount === 0) return null;

  return (
    <section className="home-section">
      <h2 className="home-section-title">{title}</h2>
      <div className="home-section-list">{children}</div>
    </section>
  );
}
